export default "__VITE_ASSET__BpmRWGP9__"